import Vue from "vue";

const mutations = {
    setCustomers(state, customers) {
        state.customers = customers;
    },
    addCustomer(state, customer) {
        if (!state.customers.includes(customer)) {
            state.customers.push(customer);
        }
    },
    removeCustomer(state, customer) {
        const index = state.customers.indexOf(customer);
        if (index > -1) {
            state.customers.splice(index, 1);
        }
    },
    setDateRange(state, dateRange) {
        state.dateRange = dateRange;
    },
    setActiveTab(state, tab) {
        state.activeTab = tab;
    },
    setAnalysisMode(state, mode) {
        state.analysisMode = mode;
    },
    setAnalysisResult(state, { analysisType, result }) {
        Vue.set(state.analysisResults, analysisType, result);
    },
    setAnalysisId(state, { analysisType, analysisId }) {
        Vue.set(state.analysisIds, analysisType, analysisId);
    },
    setLoading(state, { analysisType, loading }) {
        Vue.set(state.loadingMap, analysisType, loading);
    },
    setProgress(state, { analysisType, progress }) {
        Vue.set(state.progressMap, analysisType, progress);
    },
    setAnalysisParameter(state, { analysisType, paramKey, value }) {
        Vue.set(state.analysisParameters[analysisType], paramKey, value);
    },
    setActivePoller(state, { analysisType, poller }) {
        Vue.set(state.activePollers, analysisType, poller);
    },
    clearActivePoller(state, analysisType) {
        const poller = state.activePollers[analysisType];
        if (poller && poller.cancel) {
            poller.cancel();
        }
        Vue.set(state.activePollers, analysisType, null);
    },
    setBackendMessage(state, { analysisType, message }) {
        Vue.set(state.backendMessages, analysisType, message);
    },
    clearAnalysisResult(state, analysisType) {
        Vue.set(state.analysisResults, analysisType, null);
        Vue.set(state.analysisIds, analysisType, null);
        Vue.set(state.progressMap, analysisType, 0);
    },
    setMultiHopResults(state, result) {
        state.multiHopResults = result;
    },
    setMultiHopLoading(state, loading) {
        state.multiHopLoading = loading;
    },
    setConnectionPaths(state, paths) {
        state.connectionPaths = paths;
    },
    setConnectionLoading(state, loading) {
        state.connectionLoading = loading;
    },
    clearMultiHopResults(state) {
        state.multiHopResults = null;
        state.connectionPaths = [];
    },
    clearActivePollers(state) {
        Object.keys(state.activePollers).forEach((key) => {
            if (state.activePollers[key]) {
                const poller = state.activePollers[key];
                if (poller && poller.cancel) {
                    poller.cancel();
                }
            }
            Vue.set(state.activePollers, key, null);
        });
    },
    setNarrativeData(state, data) {
        state.narrativeData = data;
    },
    setInsightCards(state, cards) {
        state.insightCards = cards;
    },
    clearAllResults(state) {
        const keys = Object.keys(state.analysisResults);
        keys.forEach((key) => {
            Vue.set(state.analysisResults, key, null);
            Vue.set(state.analysisIds, key, null);
            Vue.set(state.progressMap, key, 0);
        });
        const pollerKeys = Object.keys(state.activePollers);
        pollerKeys.forEach((key) => {
            const poller = state.activePollers[key];
            if (poller && poller.cancel) {
                poller.cancel();
            }
            Vue.set(state.activePollers, key, null);
        });
    }
};

export default mutations;
